<template>
  <div v-if="items.length != 0">
    <div
      class="font-weight-bold black--text"
      style="font-size: 18px"
      :class="$vuetify.breakpoint.xsOnly ? 'mb-5' : 'mb-6'"
    >
      <v-row class="ma-0" align="center">
        <span :style="items.length == 0 ? 'visibility: hidden' : ''">
          Trades to Focus
        </span>
        <v-spacer />
        <v-btn
          @click="addTrade()"
          color="#2d8cff"
          class="mx-auto add-trade-button white--text d-none d-sm-flex"
        >
          <v-icon color="#fff">mdi-plus</v-icon> Add new trade
        </v-btn>
      </v-row>

      <!-- <v-spacer /> -->
      <!-- <v-btn
        @click="addTrade()"
        width="150"
        height="40"
        color="#2d8cff"
        class="mt-4 mx-auto add-trade-button"
      >
        <v-icon color="#fff">mdi-plus</v-icon> rade
      </v-btn> -->
    </div>

    <!-- <v-row class="ma-0" v-if="loading && page === 1">
      <v-col cols="6" md="4" v-for="item in 3" :key="item">
        <v-card class="mt-2">
          <v-skeleton-loader type="image, article" />
        </v-card>
      </v-col>
    </v-row> -->

    <!-- <v-row v-else class="ma-0">
      <v-col
        cols="6"
        md="4"
        class="pa-1"
        v-for="(item, index) in items"
        :key="index"
      >
        <TradeUserData class="mt-2" :profile_data="item" />
      </v-col>
    </v-row> -->

    <!-- <TradeUserData
      :showDivider="true"
      @reload-trending-trades="reloadTrades"
      @reload-home-trades="reloadTrades"
      @home-reload="reloadTrades"
      @reloadTradesHome="reloadTrades"
      class="mb-4"
      :home="true"
      :show_button="false"
      :trade_data="item"
      :show_more="true"
      :is_user_content="true"
      v-for="(item, index) in items"
      :key="index"
      :ref="`${item.id}`"
    /> -->
    <TradeCard
      class="mb-8"
      v-for="item in items"
      :key="item.id"
      :trade_data="item"
      :ref="`${item.id}`"
    >
    </TradeCard>

    <v-col class="mt-4" v-if="isNextPage !== null">
      <v-btn
        color="white"
        block
        @click="nextPage"
        class="primary--text font-weight-bold text-capitalize body-1"
      >
        Show More
      </v-btn>
    </v-col>
  </div>
</template>

<script>
// import TradeUserData from "@/components/Trade/TradeUserData.vue";
import TradeCard from "@/components/TradeCard.vue";

import helper from "@/helper/index";
export default {
  components: { TradeCard },
  data: () => ({
    upcomingTradesLoading: false,
    helper: helper,
    trade_ids: [],
    // security_ids: [],
    // socket: null,
  }),
  computed: {
    socket: {
      get() {
        return this.$store.state.upcomingTrades.socket;
      },
      set(value) {
        return this.$store.dispatch("upcomingTrades/setSocket", value);
      },
    },
    security_ids() {
      return this.$store.state.upcomingTrades.security_ids;
    },
    page: {
      get() {
        return this.$store.state.upcomingTrades.page;
      },
      set(value) {
        this.$store.commit("upcomingTrades/setPage", value);
      },
    },
    isNextPage: {
      get() {
        return this.$store.state.upcomingTrades.isNextPage;
      },
      set(value) {
        this.$store.commit("upcomingTrades/setIsNextPage", value);
      },
    },
    items() {
      return this.$store.state.upcomingTrades.allItems;
    },
    loading() {
      return this.$store.state.upcomingTrades.loading;
    },
  },
  watch: {
    page() {
      this.getData();
    },
    // items() {
    //   this.manupulate_ids();
    // },
  },
  methods: {
    manupulate_ids() {
      if (this.items.length) {
        this.items.array.forEach((element) => {
          if (!this.trade_ids.includes(element.id))
            this.trade_ids.push(element.id);
          if (!this.security_ids.includes(element.security)) {
            this.security_ids.push(element.security);
          }
        });
        const data = {
          type: "security",
          id: this.security_ids,
        };
        this.socket.send(JSON.stringify(data));
        console.log(data, "ids");
      }
    },
    getData() {
      this.$store.dispatch("upcomingTrades/getUpcomingTrades", {});
      this.initializeWebSocket();
    },
    nextPage() {
      if (this.isNextPage !== null) this.page++;
    },
    reloadTrades() {
      this.$store.dispatch("upcomingTrades/resetPage", {});
    },
    addTrade() {
      this.$logEvent("add_trade_trending_page");
      // console.log("trending event fire");

      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_add_trade_trending_page");
      }
      this.$emit("add-trade");
    },
    initializeWebSocket() {
      // const socketUrl = "ws://localhost:8001/ws/security/";
      const socketUrl = process.env.VUE_APP_WEBSOCKET_URL;

      this.socket = new WebSocket(socketUrl);

      // this.$store.dispatch("upcomingTrades/setSocket", this.socket);

      this.socket.onopen = () => {
        // const data = {
        //   type: "security",
        //   id: this.security_ids,
        // };
        // // this.socket.send(JSON.stringify(data));
        // this.socket.send(JSON.stringify(data));
        console.log("WebSocket connection established.");
      };

      this.socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        const { pk, fields } = data;
        // console.log(this.security_ids, "sec");
        if (this.security_ids.includes(pk)) {
          let filtered_trades = this.items.filter(
            (item) => item.security == pk
          );
          var indexes = [];
          for (const itm of filtered_trades) {
            let ind = this.items.findIndex((item) => item.id == itm.id);
            if (ind >= 0) {
              indexes.push(ind);
            }
          }
          for (const index of indexes) {
            let cal_figure = this.helper.caculate_figures(
              this.items[index],
              fields
            );
            this.items[index].live_price = fields.live_price.toFixed(2);
            this.items[index].price_up_down = cal_figure.up_down;
            this.items[index].profit_percent = cal_figure.profit_percent;
            this.items[index].pl_data = cal_figure.pl_price;
            this.items[index].pl_percent = cal_figure.pl_percent;
            let id = this.items[index].id;
            let ref = [...this.$refs[`${id}`]];
            //     // ref[0].trade_data = data;
            ref[0].trade_data.live_price = fields.live_price.toFixed(2);
            ref[0].trade_data.price_up_down = cal_figure.up_down;
            ref[0].trade_data.profit_percent = cal_figure.profit_percent;
            ref[0].trade_data.pl_data = cal_figure.pl_price;
            ref[0].trade_data.pl_percent = cal_figure.pl_percent;
            // console.log(this.trades[index], cal_figure, "figures");
            // console.log(fields.name, fields.live_price, "figures");
          }
          // let index = this.items.findIndex((item) => item.security == pk);
        }
      };

      this.socket.onclose = (error) => {
        console.log(error, "WebSocket connection closed.");
      };
    },
    // initializeWebSocket() {
    //   // const socketUrl = "ws://localhost:8001/ws/security/";
    //   const socketUrl = `${process.env.VUE_APP_WEBSOCKET_BASE_URL}trade/`;

    //   this.socket = new WebSocket(socketUrl);

    //   this.socket.onopen = () => {
    //     console.log("WebSocket connection established.");
    //     const data = {
    //       type: "trade",
    //       id: this.trade_ids,
    //     };
    //     // this.socket.send(JSON.stringify(data));
    //     this.socket.send(JSON.stringify(data));
    //   };

    //   this.socket.onmessage = (event) => {
    //     const data = JSON.parse(event.data);
    //     console.log(data, "data");
    //     let index = this.trades.findIndex((itm) => itm.id == data.id);
    //     //trade update
    //     this.trades[index]["live_price"] = data.live_price;
    //     this.trades[index]["price_up_down"] = data.price_up_down;
    //     this.trades[index]["profit_percent"] = data.profit_percent;
    //     this.trades[index]["pl_data"] = data.pl_data;
    //     this.trades[index]["pl_percent"] = data.pl_percent;
    //     this.trades[index]["target_price"] = data.target_price;
    //     this.trades[index]["stop_loss"] = data.stop_loss;

    //     //trade card update
    //     let ref = [...this.$refs[`${data.id}`]];
    //     // ref[0].trade_data = data;
    //     ref[0].trade_data.live_price = data.live_price;
    //     ref[0].trade_data.price_up_down = data.price_up_down;
    //     ref[0].trade_data.profit_percent = data.profit_percent;
    //     ref[0].trade_data.pl_data = data.pl_data;
    //     ref[0].trade_data.pl_percent = data.pl_percent;
    //     ref[0].trade_data.target_price = data.target_price;
    //     ref[0].trade_data.stop_loss = data.stop_loss;
    //   };

    //   this.socket.onclose = (error) => {
    //     console.log(error, "WebSocket connection closed.");
    //   };
    // },
    closeWebSocket() {
      if (this.socket) {
        this.socket.close();
      }
    },
  },
  beforeDestroy() {
    this.closeWebSocket();
  },
  mounted() {
    this.$store.dispatch("trendingTrades/resetPage");
    this.getData();
  },
};
</script>

<style></style>
